'use client';

import { useLayoutEffect } from 'react';

import {
  clearLoginBodyLeftovers,
  removeRouteStylesheets,
  enableRouteStylesheets,
} from '@/lib/styles/route-stylesheets';

const LOGIN_BODY_CLASS = 'kw-login-body';
const LOGIN_READY_CLASS = 'kw-login-ready';

type LoginBodyResetProps = {
  fontClassNames?: string;
};

/**
 * Applies login body isolation before paint. Disable foreign sheets and
 * enable our own sheets so soft-nav doesn't conflict.
 */
export function LoginBodyReset({ fontClassNames }: LoginBodyResetProps) {
  useLayoutEffect(() => {
    const body = document.body;
    const fontClasses = fontClassNames ? fontClassNames.split(/\s+/).filter(Boolean) : [];

    body.classList.add(LOGIN_BODY_CLASS);
    fontClasses.forEach((className) => body.classList.add(className));
    
    // Enable our own sheets in case they were disabled by a soft-nav away and back
    enableRouteStylesheets('login');
    // Disable foreign sheets
    removeRouteStylesheets(['marketing', 'ai-bio']);

    const markReady = () => {
      body.classList.add(LOGIN_READY_CLASS);
    };

    if (document.fonts && document.fonts.ready) {
      void document.fonts.ready.then(markReady);
    } else {
      markReady();
    }

    return () => {
      clearLoginBodyLeftovers(body);
      fontClasses.forEach((className) => body.classList.remove(className));
    };
  }, [fontClassNames]);

  return null;
}
